'use client';

import Link from 'next/link';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

type HotTagLinkProps = {
  id: string;
};

const HotTagLink = ({ id }: HotTagLinkProps) => {
  const onClickTag = () => {
    const GTM_EVENT = {
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAG,
      [GTMEventKey.SECTION]: 'News_Category_熱門排行',
      [GTMEventKey.CLICK_ITEM]: `熱門追蹤標籤＿${id}`
    };
    sendGTM(GTM_EVENT);
  };

  return (
    <Link href={`/tag/${id}`} onClick={onClickTag} prefetch={false}>
      {id}
    </Link>
  );
};

export default HotTagLink;
